import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  ShieldCheck,
  Clock3,
  ArrowLeft,
  CheckCircle2,
  LockKeyhole
} from "lucide-react";
import "./verification.status.css";

export default function VerificationPending() {
  const navigate = useNavigate();

  const user = JSON.parse(
    localStorage.getItem("civilink_user")
  );

  const status =
    user?.professionalVerification?.status;


  /* =====================================================
     SAFETY GUARD
  ===================================================== */

  useEffect(() => {

    if (!user) {
      navigate("/");
      return;
    }

    if (status !== "pending") {
      navigate("/profile");
    }

  }, [navigate, status, user]);


  if (!user || status !== "pending") {
    return null;
  }


  /* =====================================================
     SUBMITTED DATE
  ===================================================== */

  const submittedDate = user.updatedAt
    ? new Date(user.updatedAt).toLocaleDateString(
        "en-IN",
        {
          day: "numeric",
          month: "short",
          year: "numeric"
        }
      )
    : "Recently";


  return (
    <div className="verification-page">

      {/* =================================================
          HEADER
      ================================================= */}

      <header className="verification-header">

        <button
          type="button"
          className="verification-back-btn"
          onClick={() =>
            navigate("/profile")
          }
          aria-label="Back to profile"
        >
          <ArrowLeft size={19} />
        </button>

        <div>

          <span className="verification-eyebrow">
            CIVILINK PROFESSIONAL
          </span>

          <h1>
            Verification Status
          </h1>

        </div>

      </header>


      {/* =================================================
          MAIN CARD
      ================================================= */}

      <main className="verification-card">

        {/* STATUS ICON */}

        <div className="verification-status-icon">

          <Clock3 size={30} />

        </div>


        {/* TITLE */}

        <span className="verification-status-label">
          VERIFICATION IN PROGRESS
        </span>

        <h2>
          Your verification is under review
        </h2>

        <p className="verification-message">
          Your professional qualification has been
          submitted successfully. Our Civilink team
          will review the information and update your
          professional status once the verification is
          complete.
        </p>


        {/* =================================================
            DETAILS
        ================================================= */}

        <div className="verification-details">

          <div className="verification-detail">

            <span>
              Profession
            </span>

            <strong>
              {user.profession}
            </strong>

          </div>


          <div className="verification-detail">

            <span>
              Status
            </span>

            <strong className="status-pending">
              <Clock3 size={14} />
              Pending
            </strong>

          </div>


          <div className="verification-detail">

            <span>
              Submitted
            </span>

            <strong>
              {submittedDate}
            </strong>

          </div>

        </div>


        {/* =================================================
            PROCESS
        ================================================= */}

        <div className="verification-process">

          <div className="process-item completed">

            <div className="process-icon">
              <CheckCircle2 size={17} />
            </div>

            <div>
              <strong>
                Application submitted
              </strong>

              <span>
                Your qualification was received.
              </span>
            </div>

          </div>


          <div className="process-line" />


          <div className="process-item active">

            <div className="process-icon">
              <Clock3 size={17} />
            </div>

            <div>
              <strong>
                Civilink review
              </strong>

              <span>
                Your documents are being reviewed.
              </span>
            </div>

          </div>


          <div className="process-line" />


          <div className="process-item">

            <div className="process-icon">
              <ShieldCheck size={17} />
            </div>

            <div>
              <strong>
                Professional verification
              </strong>

              <span>
                Your verified badge will appear after approval.
              </span>
            </div>

          </div>

        </div>


        {/* =================================================
            PRIVACY NOTICE
        ================================================= */}

        <div className="verification-notice">

          <div className="notice-icon">
            <LockKeyhole size={17} />
          </div>

          <div>

            <strong>
              Your profile remains protected
            </strong>

            <p>
              Your professional profile will remain
              hidden from professional listings until
              verification is approved.
            </p>

          </div>

        </div>


        {/* =================================================
            ACTION
        ================================================= */}

        <button
          type="button"
          className="verification-home-btn"
          onClick={() =>
            navigate("/home")
          }
        >
          Continue to Civilink
        </button>

        <button
          type="button"
          className="verification-profile-btn"
          onClick={() =>
            navigate("/profile")
          }
        >
          View Profile
        </button>

      </main>

    </div>
  );
}